import { type AgentThreadSubject } from '@/shared/api/agentCore/agentCoreApi';

// The thread subject binds the chat to one entity. Document-mode chats are
// document-bound even when the surrounding page context says otherwise;
// a general draft and non-entity pages have no subject.
export const resolveChatThreadSubject = (
  documentMode: boolean,
  documentID: string,
  pageSubject?: AgentThreadSubject,
): AgentThreadSubject | null =>
  documentMode && documentID
    ? { type: 'document', id: documentID }
    : pageSubject ?? null;

export const threadSubjectKey = (subject: AgentThreadSubject | null): string =>
  subject ? `${subject.type}:${subject.id}` : 'general';

// The patient chip already covers a plain patient subject; only a report,
// document, or encounter binding deserves its own chip next to it.
export const isEntitySubject = (
  subject: AgentThreadSubject | null,
): subject is AgentThreadSubject =>
  subject !== null && subject.type !== 'patient';
